<template>
    <v-table class="bordered" density="compact" striped="even">
        <thead>
            <tr>
                <th>Clt</th>
                <th>Nom</th>
                <th>Doss</th>
                <th>Nat</th>
                <th>Scratch</th>
                <th>Cat</th>
                <th>Temps</th>
                <th>Club</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="i in nb_rows" :key="i">
                <td class="font-weight-bold">{{ i }}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
            </tr>
        </tbody>
    </v-table>
</template>

<script>
export default {
    props: {
        nb_rows: {
            type: Number,
            default: 0,
        },
    },
}
</script>

<style lang="scss" scoped></style>